import Parameters from '../../../scenes/shared/Parameters';

export default Parameters;
